import React from 'react';
import ScannerCodeUI from './ScannerCode';
import ListLinkBoxUI from './ListLinkBox';
import InputUI from './InputUI';
import ButtonUI from './ButtonUI';
import SelectUI from './Select';
import BreadcrumbsUI from './Breadcrumbs';
import ChipsUI from './ChipsUI';
import BackButtonUI from './BackButton';
import SelectItemUI from './SelectItem';
import ModalUI from './ModalUi';
import ConfirmModalUI from './ConfirmModal';
import LabelUI from './LabelUI';
import ListPaginationUl from './ListPaginationUl';
import RadioButtonUI from './RadioButtonUI'
import PreloaderUI from './PreloaderUI'
import FabUI from './FabUI'
import { TitleUI, SubtitleUI, ButtonIconUI } from './LabelTitleUI';
import ListPaginationUlNew from './ListPaginationUlNew';
import CameraPictureUI from './CameraPictureUI';
import SelectShedUI from './SelectShedUI';
import SelectResourceUI from './SelectResourceUI';
import SelectDockUI from './SelectDockUI';
import SelectEquipmentUI from './SelectEquipmentUI';
import SelectUnitUI from './SelectUnitUI';
import SelectPrintTypeUI from './SelectPrintTypeUI';
import SelectJustificationUI from './SelectJustificationUI';
import InfiniteScrollUl from './InfiniteScrollUl';
import CollapsibleUI from './CollapsibleUI';
import ListUI from './ListUI';
import CardUI from './CardUI';
import SelectRackTypeUI from './SelectRackTypeUI';
import ConfirmButtonsUI from './ConfirmButtonsUI';
import TableUI from './TableUI';
import CustomNumberInputUI from './CustomNumberInputUI';

export const ButtonIcon = (props) => {
    return <ButtonIconUI {...props} />;
};

export const ListLinkBox = (props) => {
    return <ListLinkBoxUI {...props} />;
};

export const Fab = (props) => {
    return <FabUI {...props} />;
};

export const ListPagination = (props) => {
    return <ListPaginationUl {...props} />;
};

export const ListPaginationNew = (props) => {
    return <ListPaginationUlNew {...props} />;
};

export const Label = (props) => {
    return <LabelUI {...props} />;
};

export const Breadcrumbs = (props) => {
    return <BreadcrumbsUI {...props} />;
};

export const Preloader = (props) => {
    return <PreloaderUI {...props} />;
};

export const ConfirmModal = (props) => {
    return <ConfirmModalUI {...props} />;
};

export const Title = (props) => {
    return <TitleUI {...props} />;
};

export const Subtitle = (props) => {
    return <SubtitleUI {...props} />;
};

export const Modal = (props) => {
    return <ModalUI {...props} />;
};

export const ScannerCode = (props) => {
    return <ScannerCodeUI {...props} />;
};

export const CameraPicture = (props) => {
    return <CameraPictureUI {...props} />;
};

export const Input = (props) => {
    return <InputUI {...props} />;
};

export const CustomNumberInput = (props) => {
    return <CustomNumberInputUI {...props} />;
};

export const Button = (props) => {
    return <ButtonUI {...props} />;
};

export const Select = (props) => {
    return <SelectUI {...props} />;
};

export const Chips = (props) => {
    return <ChipsUI {...props} />;
};

export const BackButton = (props) => {
    return <BackButtonUI {...props} />;
};

export const SelectItem = (props) => {
    return <SelectItemUI {...props} />;
};

export const RadioButton = (props) => {
    return <RadioButtonUI {...props} />;
};

export const SelectShed = (props) => {
    return <SelectShedUI {...props} />;
};

export const SelectResource = (props) => {
    return <SelectResourceUI {...props} />;
};

export const SelectDock = (props) => {
    return <SelectDockUI {...props} />;
};

export const SelectEquipment = (props) => {
    return <SelectEquipmentUI {...props} />;
};

export const SelectUnit = (props) => {
    return <SelectUnitUI {...props} />;
};

export const SelectPrintType = (props) => {
    return <SelectPrintTypeUI {...props} />;
};

export const SelectJustification = (props) => {
    return <SelectJustificationUI {...props} />;
};

export const InfiniteScroll = (props) => {
    return <InfiniteScrollUl {...props} />;
};

export const Collapsible = (props) => {
    return <CollapsibleUI {...props} />;
};

export const List = (props) => {
    return <ListUI {...props} />;
};

export const Card = (props) => {
    return <CardUI {...props} />;
};

export const SelectRackType = (props) => {
    return <SelectRackTypeUI {...props} />;
};

export const ConfirmButtons = (props) => {
    return <ConfirmButtonsUI {...props} />;
};

export const Table = (props) => {
    return <TableUI {...props} />;
};

